<div [formGroup]="form">
  <div class="card">
    <div class="card-header card-header-detail" i18n>Lebensunterhalt und Aufenthaltsdetails</div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="reisedaten.lebensunterhalt.sonstigesText" i18n [class.mandatory]="isMandatory('mittel')">
              Aus welchen Mitteln wird der Lebensunterhalt in der Bundesrepublik Deutschland bestritten?</label>
            <input id="reisedaten.lebensunterhalt.sonstigesText"
                   type="text" appToUpperCase [attr.maxlength]="getMaxLength('mittel')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['mittel'])"
                   formControlName="mittel"
                   [ngbPopover]="popover_reisedaten_lebensunterhalt_sonstigesText"
                   appSaveLastFocussed
            >
            <ng-template #popover_reisedaten_lebensunterhalt_sonstigesText>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier ein, wie der Lebensunterhalt in Deutschland sichergestellt wird.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <span i18n>Gibt es eine förmliche Verpflichtungserklärung?</span>
          <div class="form-check">
            <label class="form-check-label">
              <input type="radio"
                     id="referenz.foermlicheVerpflichtungserklaerung.nein"
                     class="form-check-input"
                     formControlName="abweichenderVerpflichtungsgeber"
                     value="nein"
                     [checked]="true"
                     [ngbPopover]="popover_referenz_foermlicheVerpflichtungserklaerung"
                     appSaveLastFocussed
              >
              <span i18n>nein</span>
            </label>
            <label class="form-check-label ms-5">
              <input type="radio"
                     id="referenz.foermlicheVerpflichtungserklaerung.ja"
                     class="form-check-input"
                     formControlName="abweichenderVerpflichtungsgeber"
                     value="ja"
                     [ngbPopover]="popover_referenz_foermlicheVerpflichtungserklaerung"
                     appSaveLastFocussed
              >
              <span i18n>ja, von der Referenz</span>
            </label>
            <label class="form-check-label ms-5">
              <input type="radio"
                     id="referenz.abweichenderVerpflichtungsgeber"
                     class="form-check-input"
                     formControlName="abweichenderVerpflichtungsgeber"
                     value="jaAbweichend"
                     [ngbPopover]="popover_referenz_foermlicheVerpflichtungserklaerung"
                     appSaveLastFocussed
              >
              <span i18n>ja, durch abweichende(n) Verpflichtungsgebende(n)</span>
            </label>
          </div>
          <ng-template #popover_referenz_foermlicheVerpflichtungserklaerung>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Bestätigen Sie bitte diese Angabe nur dann, wenn eine förmliche Verpflichtungserklärung vorliegt, die von einer deutschen Behörde geprüft und beglaubigt wurde.</span>
            </app-assistant>
          </ng-template>
        </div>
      </div>
      <div class="row mb-3" *ngIf="isVerpflichtungserklaerungDataVisible">
        <div class="col-md-4">
          <div class="h-100 d-flex flex-column justify-content-between">
            <label for="verpflichtungserklaerungsgeber.foermlicheVerpflichtungserklaerung.behoerde" i18n
                   [class.mandatory]="isMandatory('verpflichtungsgebendeBehoerde')">Förmliche Verpflichtungserklärung - Behörde:</label>
            <select class="form-select form-select-sm"
                    id="verpflichtungserklaerungsgeber.foermlicheVerpflichtungserklaerung.behoerde"
                    [class.is-invalid]="errorClassRequired(form.controls['verpflichtungsgebendeBehoerde'])"
                    formControlName="verpflichtungsgebendeBehoerde"
                    [ngbPopover]="popover_referenz_foermlicheVerpflichtungserklaerung_behoerde"
                    appSaveLastFocussed
            >
              <option value=""></option>
              <option *ngFor="let behoerdeOption of behoerdeOptions" value="{{ behoerdeOption.key }}">{{ behoerdeOption.value }}</option>
            </select>
            <ng-template #popover_referenz_foermlicheVerpflichtungserklaerung_behoerde>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte wählen Sie hier die Behörde aus, die die förmliche Verpflichtungserklärung geprüft und beglaubigt hat.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4">
          <div class="h-100 d-flex flex-column justify-content-between">
            <label for="verpflichtungserklaerungsgeber.foermlicheVerpflichtungserklaerung.datum" i18n
                   [class.mandatory]="isMandatory('erklaerungDatum')">Förmliche Verpflichtungserklärung - Datum (TT.MM.JJJJ):</label>
            <div class="input-group" *ngIf="presentationModeEnum.DEFAULT === appConfig.presentationMode">
              <input angular-mydatepicker
                     id="verpflichtungserklaerungsgeber.foermlicheVerpflichtungserklaerung.datum"
                     #datumDerErklaerung="angular-mydatepicker"
                     [options]="datepickerOptions"
                     class="form-control form-control-sm w-50"
                     type="text"
                     [class.is-invalid]="errorClassRequired(form.controls['erklaerungDatum'])"
                     [attr.maxlength]="getMaxLength('erklaerungDatum')"
                     (inputFieldChanged)="onDatePickerInputFieldChanged('erklaerungDatum', $event)"
                     (blur)="onDatePickerBlur('erklaerungDatum')"
                     formControlName="erklaerungDatum"
                     [ngbPopover]="popover_referenz_foermlicheVerpflichtungserklaerung_datum"
                     appSaveLastFocussed
              />
              <ng-template #popover_referenz_foermlicheVerpflichtungserklaerung_datum>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte geben Sie hier das Datum an, an dem die förmliche Verpflichtungserklärung geprüft und beglaubigt wurde.</span>
                </app-assistant>
              </ng-template>
              <span class="input-group-text date-picker" (click)="datumDerErklaerung.toggleCalendar()"><i class="icon-calendar"></i></span>
            </div>
            <div class="input-group" *ngIf="presentationModeEnum.AP2 === appConfig.presentationMode">
              <input type="text"
                     class="form-control form-control-sm w-50"
                     value="{{dateFormatter.getFormattedDatePickerValue(form.value.erklaerungDatum)}}"
                     disabled
              />
              <span class="input-group-text date-picker"><i class="icon-calendar"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mb-2" i18n>Vorgesehener Aufenthaltsort in der Bundesrepublik Deutschland:</div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="zusatzangaben.aufenthaltStrasse" i18n [class.mandatory]="isMandatory('aufenthaltStrasse')">Straße (falls bekannt):</label>
                <input id="zusatzangaben.aufenthaltStrasse"
                       type="text" appToUpperCase
                       [attr.maxlength]="getMaxLength('aufenthaltStrasse')"
                       class="form-control form-control-sm"
                       [class.is-invalid]="errorClassRequired(form.controls['aufenthaltStrasse'])"
                       formControlName="aufenthaltStrasse"
                       [ngbPopover]="popover_zusatzangaben_aufenthaltStrasse"
                       appSaveLastFocussed
                >
                <ng-template #popover_zusatzangaben_aufenthaltStrasse>
                  <app-assistant (assistantDisabled)="disableAssistant()">
                    <span i18n>Bitte tragen Sie hier, falls bereits bekannt, die Straße ein, in der Sie wohnen werden.</span>
                  </app-assistant>
                </ng-template>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="zusatzangaben.aufenthaltHausnummer" i18n [class.mandatory]="isMandatory('aufenthaltHausnummer')">
                  Hausnummer (falls bekannt):</label>
                <input id="zusatzangaben.aufenthaltHausnummer"
                       type="text" appToUpperCase [attr.maxlength]="getMaxLength('aufenthaltHausnummer')"
                       class="form-control form-control-sm"
                       [class.is-invalid]="errorClassRequired(form.controls['aufenthaltHausnummer'])"
                       formControlName="aufenthaltHausnummer"
                       [ngbPopover]="popover_zusatzangaben_aufenthaltHausnummer"
                       appSaveLastFocussed
                >
                <ng-template #popover_zusatzangaben_aufenthaltHausnummer>
                  <app-assistant (assistantDisabled)="disableAssistant()">
                    <span i18n>Bitte tragen Sie hier die Hausnummer des geplanten Wohnsitzes in Deutschland ein.</span>
                  </app-assistant>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="mb-3">
                <label for="zusatzangaben.aufenthaltPlz" i18n [class.mandatory]="isMandatory('aufenthaltPlz')">Postleitzahl:</label>
                <input id="zusatzangaben.aufenthaltPlz"
                       type="text" appToUpperCase [attr.maxlength]="getMaxLength('aufenthaltPlz')"
                       class="form-control form-control-sm"
                       [class.is-invalid]="errorClassRequired(form.controls['aufenthaltPlz'])"
                       formControlName="aufenthaltPlz"
                       [ngbPopover]="popover_zusatzangaben_aufenthaltPlz"
                       appSaveLastFocussed
                >
                <ng-template #popover_zusatzangaben_aufenthaltPlz>
                  <app-assistant (assistantDisabled)="disableAssistant()">
                    <span i18n>Bitte tragen Sie hier die fünfstellige Postleitzahl des geplanten Aufenthaltsorts (Wohnsitz) in Deutschland ein.</span>
                  </app-assistant>
                </ng-template>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-3">
                <label for="zusatzangaben.aufenthaltOrt" i18n [class.mandatory]="isMandatory('aufenthaltort')">Ort:</label>
                <input id="zusatzangaben.aufenthaltOrt"
                       type="text" appToUpperCase [attr.maxlength]="getMaxLength('aufenthaltort')"
                       class="form-control form-control-sm"
                       [class.is-invalid]="errorClassRequired(form.controls['aufenthaltort'])"
                       formControlName="aufenthaltort"
                       [ngbPopover]="popover_zusatzangaben_aufenthaltOrt"
                       appSaveLastFocussed
                >
                <ng-template #popover_zusatzangaben_aufenthaltOrt>
                  <app-assistant (assistantDisabled)="disableAssistant()">
                    <span i18n>Bitte tragen Sie hier den Ort ein, an dem Sie beabsichtigen, sich anzumelden. Falls die genaue Adresse noch nicht bekannt ist, kann auch die Adresse der Bildungseinrichtung/des Arbeitgebers eingetragen werden.</span>
                  </app-assistant>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4 mt-xs-0 mt-md-3">
          <span i18n>Wie werden Sie untergebracht sein?</span>
          <div class="form-check ms-4">
            <div>
              <input id="zusatzangaben.aufenthaltArt.einzelzimmer"
                     class="me-3 form-check-input"
                     type="checkbox"
                     value="Einzelzimmer"
                     formControlName="einzelzimmer"
                     [ngbPopover]="popover_zusatzangaben_aufenthaltArt_einzelzimmer"
                     appSaveLastFocussed
              >
              <span i18n>Einzelzimmer</span>
              <ng-template #popover_zusatzangaben_aufenthaltArt_einzelzimmer>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte aktivieren Sie dieses Feld, wenn die Unterkunft ein Einzelzimmer sein wird.</span>
                </app-assistant>
              </ng-template>
            </div>
            <div>
              <input id="zusatzangaben.aufenthaltArt.wohnung"
                     class="me-3 form-check-input"
                     type="checkbox"
                     value="Wohnung"
                     formControlName="wohnung"
                     [ngbPopover]="popover_zusatzangaben_aufenthaltArt_wohnung"
                     appSaveLastFocussed
              >
              <span i18n>Wohnung mit</span>
              <ng-template #popover_zusatzangaben_aufenthaltArt_wohnung>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte aktivieren Sie dieses Feld, wenn die Unterkunft eine Wohnung sein wird.</span>
                </app-assistant>
              </ng-template>

              <input id="zusatzangaben.aufenthaltArt.zimmer"
                     type="text" appToUpperCase [attr.maxlength]="getMaxLength('zimmer')"
                     style="width: 2em; padding: .2em; text-align: center;"
                     class="form-control form-control-sm d-inline-block"
                     [class.is-invalid]="errorClassRequired(form.controls['zimmer'])"
                     formControlName="zimmer"
                     [ngbPopover]="popover_zusatzangaben_aufenthaltArt_zimmer"
                     appSaveLastFocussed
              >
              <span i18n>Zimmern</span>
              <ng-template #popover_zusatzangaben_aufenthaltArt_zimmer>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte geben Sie hier die Anzahl der Zimmer der Wohnung an.</span>
                </app-assistant>
              </ng-template>
            </div>
            <div>
              <input class="me-3 form-check-input"
                     type="checkbox"
                     value="sammelunterkunft"
                     formControlName="sammelunterkunft"
                     id="zusatzangaben.aufenthaltArt.sammelunterkunft"
                     [ngbPopover]="popover_zusatzangaben_aufenthaltArt_sammelunterkunft"
                     appSaveLastFocussed
              >
              <span i18n>Sammelunterkunft</span>
              <ng-template #popover_zusatzangaben_aufenthaltArt_sammelunterkunft>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte aktivieren Sie dieses Feld, wenn die Unterkunft eine Sammelunterkunft sein wird.</span>
                </app-assistant>
              </ng-template>
            </div>
            <div>
              <input class="me-3 form-check-input"
                     type="checkbox"
                     value="sonstiges"
                     formControlName="sonstiges"
                     id="zusatzangaben.aufenthaltArt.sonstiges"
                     [ngbPopover]="popover_zusatzangaben_aufenthaltArt_sonstiges"
                     appSaveLastFocussed
              >
              <span i18n>Sonstiges (bitte erläutern)</span>
              <ng-template #popover_zusatzangaben_aufenthaltArt_sonstiges>
                <app-assistant (assistantDisabled)="disableAssistant()">
                  <span i18n>Bitte aktivieren Sie dieses Feld, wenn Sie anderweitig untergebracht werden.</span>
                </app-assistant>
              </ng-template>
            </div>
          </div>
          <input id="zusatzangaben.aufenthaltArt.sonstigesText"
                 *ngIf="form.value.sonstiges"
                 type="text" appToUpperCase [attr.maxlength]="getMaxLength('sonstigesTxt')"
                 class="form-control form-control-sm"
                 [class.is-invalid]="errorClassRequired(form.controls['sonstigesTxt'])"
                 formControlName="sonstigesTxt"
                 [ngbPopover]="popover_zusatzangaben_aufenthaltArt_sonstigesText"
                 appSaveLastFocussed
          >
          <ng-template #popover_zusatzangaben_aufenthaltArt_sonstigesText>
            <app-assistant (assistantDisabled)="disableAssistant()">
              <span i18n>Sollten Sie anderweitig untergebracht sein, tragen Sie hier bitte Details dazu ein.</span>
            </app-assistant>
          </ng-template>
        </div>
        <div class="col-md-4 mt-3">
          <label for="antragsteller.personendaten.wohnortImAusland" i18n>
            Wird ständiger Wohnort außerhalb der Bundesrepublik Deutschland beibehalten?</label>
          <div class="form-check ms-4">
            <input type="checkbox"
                   class="me-3 mt-2 form-check-input"
                   value="ja"
                   id="antragsteller.personendaten.wohnortImAusland"
                   formControlName="wohnortImAusland"
                   [ngbPopover]="popover_antragsteller_personendaten_wohnortImAusland"
                   appSaveLastFocussed
            >
            <span i18n>ja</span><br>
            <ng-template #popover_antragsteller_personendaten_wohnortImAusland>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte aktivieren Sie dieses Feld, wenn Sie weiterhin einen Wohnsitz außerhalb Deutschlands behalten werden.</span>
              </app-assistant>
            </ng-template>
          </div>
          <div class="" *ngIf="form.value.wohnortImAusland">
            <label for="antragsteller.personendaten.wohnortImAuslandOrt" i18n [class.mandatory]="isMandatory('wohnortImAuslandOrt')">
              Falls ja, welcher Wohnort?</label>
            <input id="antragsteller.personendaten.wohnortImAuslandOrt"
                   type="text" appToUpperCase [attr.maxlength]="getMaxLength('wohnortImAuslandOrt')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['wohnortImAuslandOrt'])"
                   formControlName="wohnortImAuslandOrt"
                   [ngbPopover]="popover_antragsteller_personendaten_wohnortImAuslandOrt"
                   appSaveLastFocussed
            >
            <ng-template #popover_antragsteller_personendaten_wohnortImAuslandOrt>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte tragen Sie hier ein, welchen Wohnsitz außerhalb Deutschlands Sie beibehalten werden.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>
        <div class="col-md-4 mt-3">
          <label for="antragsteller.personendaten.mitreisendeFamilienangehoerige" i18n>Sollen Familienangehörige mit einreisen?</label>
          <div class="form-check ms-4">
            <input class="me-3 mt-2 form-check-input"
                   type="checkbox"
                   value="ja"
                   id="antragsteller.personendaten.mitreisendeFamilienangehoerige"
                   formControlName="mitreisendeFamilienangehoerige"
                   [ngbPopover]="popover_antragsteller_personendaten_mitreisendeFamilienangehoerige"
                   appSaveLastFocussed
            >
            <span i18n>ja</span><br>
            <ng-template #popover_antragsteller_personendaten_mitreisendeFamilienangehoerige>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte aktivieren Sie dieses Feld, wenn auch Familienangehörige für einen langfristigen Aufenthalt mit nach Deutschland einreisen werden.</span>
              </app-assistant>
            </ng-template>
          </div>
          <div class="" *ngIf="form.value.mitreisendeFamilienangehoerige">
            <label for="antragsteller.personendaten.mitreisendeFamilienangehoerigeText" i18n
                   [class.mandatory]="isMandatory('mitreisendeFamilienangehoerigeText')">Falls ja, welche?</label>
            <input id="antragsteller.personendaten.mitreisendeFamilienangehoerigeText"
                   type="text" appToUpperCase [attr.maxlength]="getMaxLength('mitreisendeFamilienangehoerigeText')"
                   class="form-control form-control-sm"
                   [class.is-invalid]="errorClassRequired(form.controls['mitreisendeFamilienangehoerigeText'])"
                   formControlName="mitreisendeFamilienangehoerigeText"
                   [ngbPopover]="popover_antragsteller_personendaten_mitreisendeFamilienangehoerigeText"
                   appSaveLastFocussed
            >
            <ng-template #popover_antragsteller_personendaten_mitreisendeFamilienangehoerigeText>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte geben Sie hier in Deutsch oder Englisch an, welche Familienangehörigen für einen langfristigen Aufenthalt mit nach Deutschland einreisen werden.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>

        <div class="col-md-12 mt-3">
          <label for="antragsteller.personendaten.krankenversicherung" i18n>
            Haben Sie eine Krankenversicherung (längerer Aufenthalt) für die Bundesrepublik Deutschland?</label>
          <div class="form-check">
            <input class="mt-2 form-check-input"
                   type="checkbox"
                   value="ja"
                   id="antragsteller.personendaten.krankenversicherung"
                   formControlName="krankenversicherung"
                   [ngbPopover]="popover_antragsteller_personendaten_krankenversicherung"
                   appSaveLastFocussed
            >
            <span i18n>ja</span><br>
            <ng-template #popover_antragsteller_personendaten_krankenversicherung>
              <app-assistant (assistantDisabled)="disableAssistant()">
                <span i18n>Bitte aktivieren Sie dieses Feld, falls Sie eine Krankenversicherung für Deutschland haben, die über eine Reisekrankenversicherung für einen Aufenthalt bis zu 90 Tage hinausgeht und für einen längeren Aufenthalt gilt.</span>
              </app-assistant>
            </ng-template>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
